module.exports = __webpack_public_path__ + "static/media/icon-agep-messages.6e52065c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/assets/img/icon-agep-messages.svg
// module id = 609
// module chunks = 0